###
Make Vue filters
###
Vue = require 'vue'
{ textOf } = require './utils'

# Get text of field
Vue.filter 'prismicText', textOf



// WEBPACK FOOTER //
// ./src/utils/prismic/filters.coffee